import { LogtoProvider } from "@logto/react";
import type { FC, PropsWithChildren } from "react";

import { dxmSsoConfig } from "src/auth/dxmSsoConfig";

/**
 * DXM SSO only drives the browser redirect and hands us an ID token; the API exchanges it for its
 * own HttpOnly session cookie. Without DXM SSO config (local only) the site offers dev login.
 */
export const AuthProvider: FC<PropsWithChildren> = ({ children }) =>
	dxmSsoConfig ? <LogtoProvider config={dxmSsoConfig}>{children}</LogtoProvider> : children;
